import { jwtDecode } from "jwt-decode"

export const getTokenPayload = () => {

    const token = localStorage.getItem("token");

    if(token){
        return jwtDecode(token);
    }

    return {};
}